import { AbTestingProvider } from '../application/ports/AbTestingProvider';
import { ABTesting } from '../frameworks_drivers/redux/reducers/abTest/abTesting';

export class AbTestingAdapter implements AbTestingProvider {
  constructor(private readonly abTesting: ABTesting) {}

  getAll(): Record<string, string | null> {
    return {
      pricing: this.abTesting.pricing?.scenario ?? null,
      stockShortage: this.abTesting.stockShortage?.scenario ?? null
    };
  }
}
